module.exports = {
  "CS_info2_Network_Image_HvHe": "Imagen en sitio web",
  "CS_one_Batch_configuration_Ffmp": "Configuración por grupos",
  "CS_5_When_the_PbND": "Este usuario que reporta es un pasajero. Solo se pueden aplicar herramientas de pasajero.",
  "CS_one_Scenario_ENG_mFbn": "Escenario (en-US)",
  "CS_info_Comments_failed_mQNX": "No se pudo agregar el comentario.",
  "CS_5_Do_not_kYRj": "Has hecho este proceso demasiadas veces.",
  "CS_2_It_is_vdcu": "Por favor, responde primero a través de un mensaje en la app (también se enviará una notificación por correo electrónico). En caso de que tengas alguna duda sobre el proceso, puedes consultarlo con tu supervisor.",
  "CS_1_Template_oNtV": "Plantilla",
  "CS_tickets_User_Type_Wdya": "Tipo de usuario",
  "CS_info2_Please_fill_uLvw": "Ingresa...",
  "CS_one_Operation_Log_hsdo": "Registro de acciones",
  "CS_one_Tips_vbZx": "Aviso importante",
  "CS_one_Upload_successfully_DliZ": "El archivo se cargó con éxito. Entrará en vigencia en el país correspondiente luego de crearlo. Informa a los colegas pertinentes en el país en cuestión.",
  "CS_info2_Cancel_link_vxaa": "Quitar link",
  "CS_1_Action_pnrH": "Acciones",
  "CS_pop_The_conversation_dKAF": "Hora de inicio de la llamada",
  "CS_one_Upload_files_TzsC": "Cargar archivo",
  "CS_1_Operational_results_nOpZ": "Resultado de la acción",
  "CS_one_Please_check_SuZo": "2. Carga la plantilla completada (asegúrate de que todo esté ingresado correctamente antes de cargarla).",
  "CS_1_Temporary_CTPp": "Guardar temporalmente",
  "CS_1_Solved_ooGh": "Resuelto",
  "CS_page_Unable_to_aXip": "No se pudo crear el ticket.",
  "CS_one_Enter_rfGy": "Ingresa",
  "CS_1_Message_Title_AJzH": "Asunto",
  "CS_2_Worksheet_ID_SxiT": "La identificación del ticket se genera al crearlo.",
  "CS_2_Copy_the_hSGF": "Se copió el número de teléfono y se registró la acción. Recuerda seguir la política de seguridad de la información de la empresa.",
  "CS_one_Classification_of_qEgR": "Gestión de la razón de contacto",
  "ark.global.cs.field.values.ticket_tab_im": "Chat en vivo",
  "CS_qa_This_behavior_dZrQ": "Se registraron las operaciones en esta página. Recuerda seguir las políticas de seguridad de la información de la empresa.",
  "CS_Page_Driver_List_Uxwj": "Lista de conductores",
  "CS_1_Thank_you_WUlL": "¡Gracias por tus comentarios!",
  "CS_info_Select_Question_QkZC": "Selecciona una razón de contacto",
  "CS_5_Your_query_uvJB": "Se alcanzó el máximo de consultas.",
  "CS_one_Determination_GUbi": "Confirmar",
  "CS_buchong_eFit_JNbR": "No se pudo encontrar la información de la orden porque el número de teléfono no es válido o el usuario no está registrado.",
  "CS_Page_Rider_Details_Ovwp": "Detalles del pasajero: identificación del pasajero",
  "CS_1_Amount_mYAW": "Monto",
  "CS_Page_Order_Details_oAUq": "Detalles del viaje: identificación del viaje",
  "CS_Adjustment_YdjN_bXSL": "La razón de la omisión del PNO es inadecuada. Prueba con otra.",
  "CS_Adjustment_gjOY_YpxQ": "La información del PNO no coincide con la información de la PC",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "Sin contenido",
  "CS_buchong__yLly": "No se pudieron usar las herramientas porque el número de teléfono no es válido o el usuario no está registrado.",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "Identificación del pasajero ",
  "CS_one_Batch_effective_prPl": "Validar por lotes",
  "CS_one_Country_and_Qyqv": "Configuración de países y líneas de negocio",
  "CS_page_Please_fill_ikWU": "Selecciona un grupo de tickets.",
  "CS_tickets_Three_days_pcmE": "Últimos 3 días",
  "CS_one_New_Batch_wEKW": "Crear por lote",
  "CS_one_Abandoned_ROgG": "Rechazado",
  "CS_1_Enter_content_haAO": "Ingresa el texto aquí",
  "CS_one_Description_ENG_vIZz": "Descripción (en-US)",
  "CS_page_Work_orders_MRDt": "El ticket se cerró correctamente.",
  "CS_one_Translation_configuration_lnQZ": "Configuración de la traducción",
  "CS_tickets_Compensation_deduction_GJfV": "Método de la compensación o deducción",
  "CS_info_Like_failure_mPup": "Hubo un error. Por favor, inténtalo de nuevo.",
  "CS_info2_Make_sure_zyfT": "Antes de elegir esta opción, asegúrate de que la información de la ciudad no esté disponible para este ticket.",
  "verify---id_no_co": "Verificar",
  "Help_version_Business_lines_VOJX": "Categoría",
  "CS_4_Topographic_tools_KqUl": "Mapa",
  "CS_Page_Driver_Type_UnIR": "Tipo de conductor",
  "CS_information_Order_Basis_WKGU": "Información básica del viaje",
  "Magellan_improvement_The_company_CoIp": "Información como el IM (mensaje instantáneo) y el historial de llamadas son datos confidenciales que pertenecen a la empresa. Por favor, utilízalos de acuerdo con nuestras reglas de seguridad de la información. Cada consulta será registrada por el sistema. Está estrictamente prohibido tomar fotos, descargar o revelar estos datos a cualquier tercero fuera de la empresa.",
  "CS_Page_Passenger_Details_vgGv": "Detalles del pasajero",
  "CS_pop_No_xtIB": "No",
  "CS_pop_Cancel_byla": "Cancelar",
  "Magellan_improvement_IM_Information_weuP": "Información de IM (mensaje instantáneo)",
  "CS_info2_Reset_Fiiu": "Restablecer",
  "CS_1_E_mail_rKAg": "Correo electrónico",
  "CS_tickets_Administrator_BcHW": "Administrador",
  "CS_one_Action_Type_uHTo": "Tipo de acción",
  "Magellan_improvement_Question_description_GyVD": "Descripción del problema",
  "CS_page_Do_you_UfOG": "¿Deseas transferir el ticket a {{ticketgroup}}?",
  "CS_page_Transportation_orders_UWhR": "Transferir ticket",
  "CS_tickets_One_month_IrdR": "Último mes",
  "CS_5_Unchecked_user_vuUZ": "No se encontró información de registro del usuario.",
  "CS_Settings_Countless_lEdc": "No hay datos",
  "CS_page_Transferring_the_ZnkX": "El ticket se transfirió correctamente.",
  "Magellan_improvement_Call_completed_hbKz": "Llamada finalizada",
  "CS_improvement_Passenger_JnXD": "Pasajero",
  "CS_Page_Driver_Basic_SItd": "Información básica del conductor",
  "CS_one_Description_NrBC": "Descripción",
  "CS_Adjustment_abEf_PYol": "El PNO tiene un error",
  "CS_4_Tools_can_ZQSK": "Todas las herramientas solo pueden usarse en la página de gestión de tickets del sistema de servicio al cliente.",
  "CS_one_Owner_EwUa": "Propietario",
  "CS_Page_Model_List_WVIO": "Lista de clases de vehículos",
  "CS_Page_Common_tools_FTJG": "Herramientas comunes",
  "CS_info_Click_here_MKRf": "Haz clic aquí para asociar una orden",
  "CS_thpoptimization__sSiH": "Flotilla",
  "CS_3_Optional_kdMP": "opcional",
  "CS_pop_User_Phone_hTGd": "Usar número de teléfono",
  "CS_Page_City_name_atjF": "Nombre de la ciudad",
  "CS_improvement_Call_SmCo": "Fecha y hora de la llamada",
  "Help_version_Enter_number_MyWJ": "Número de teléfono entrante",
  "CS_1_Comments_RcMN": "Enviar",
  "CS_info_This_page_Cpww": "Para evitar la demora del sistema, te sugerimos abrir un máximo de 10 pestañas de tickets en esta página y cerrar las pestañas que no sean necesarias. ¡Gracias!",
  "CS_tickets_Work_order_NQJE": "Estado del ticket",
  "CS_one_Entered_into_mEwl": "Vigente",
  "CS_Adjustment_txhj_lfbO": "Completa el PNO antes de continuar",
  "CS_tickets_Three_months_Jdzc": "Últimos 3 meses",
  "CS_1_Order_ID_bsCY": "Identificación de la orden",
  "CS_tool_Work_order_LjeC": "Estado del ticket",
  "CS_Page_Trip_Compl_Vcnk": "Hora de finalización del viaje",
  "CS_page_No_permissions_mYZG": "No tienes permiso para transferir este ticket.",
  "CS_1_Send_email_DDPi": "Confirmar el envío del correo electrónico",
  "CS_buchong__BYdr": "No se puede encontrar la información del usuario ni usar la función de verificación de permisos dinámicos porque el número de teléfono no es válido o el usuario no está registrado.",
  "CS_one_New_Problem_ORNp": "Crear una nueva razón de contacto",
  "CS_Page_Select_the_kqHS": "Selecciona las condiciones para filtrar",
  "Help_version_Country_XKEj": "País",
  "CS_translation_Selection_of_yatg": "Selecciona el motivo de la compensación",
  "CS_2_Please_select_Zapc": "Selecciona",
  "CS_2_Refund_amount_ikWV": "Monto del reembolso",
  "CS_Page_Enter_Order_TeQM": "Ingresar la identificación del viaje",
  "CS_Page_Type_SnKr": "Modelo",
  "CS_QA1_More_than_uScx": "Si hay más de {{amount}} entradas, solo se mostrarán {{amount}}.",
  "CS_one_Operation_Records_bTgJ": "Registro de acciones",
  "CS_1_ID_VNVI": "Identificación del ticket",
  "CS_pop_Bind_session_qEwk": "Agregar una llamada",
  "CS_info2_Jump_link_pUcH": "Enlace de redireccionamiento",
  "CS_tickets_The_user_iVJx": "Este usuario es un administrador de flotillas (haz clic para ver los detalles).",
  "ark.global.cs.field.values.ticket_tab_compensation": "Registro del procesamiento",
  "CS_info2_Depositary_UmEY": "Persona asignada",
  "CS_initialization_Create_a_xRhB": "Crea un ticket primero",
  "CS_pop_Bind_lDQM": "Agregar",
  "CS_Page_Order_List_IiWy": "Lista de viajes",
  "CS_one_Status_QWZW": "Estado",
  "CS_page_Site_Name_dYcm": "Nombre de la parada",
  "CS_information_Single_phone_vKdi": "Número de teléfono del solicitante",
  "CS_page__unk_uZmz": "Información de la van",
  "CS_2_Driver_balance_otCh": "Deducción al balance del conductor",
  "CS_Notice_Please_submit_iVZB": "Por favor, deja tus comentarios para esta tarjeta de proceso antes de dar clic en “Enviar”.",
  "CS_info2_Link_kBeS": "Vinculación",
  "CS_1_You_do_Czvx": "No tienes permiso para ver la información privada de los clientes. Por favor, haz la verificación del sistema o contacta al administrador.",
  "CS_info_Process_cards_ccmd": "Tarjeta del proceso",
  "CS_improvement_The_main_DIgv": "La persona que llamó colgó",
  "Help_2_More_OZUg": "Más",
  "CS_1_Recipients_jNBa": "Para",
  "CS_buchong1__XPiG": "No se puede realizar esta acción porque falló la autenticación dinámica. Completa la autenticación dinámica o comunícate con el administrador.",
  "CS_Page_Enter_email_VDKC": "Ingresar dirección de correo electrónico",
  "CS_one_Return_axWQ": "Atrás",
  "CS_tickets_Complaint_Manner_UWAQ": "Ticket relacionado con el usuario reportado",
  "CS_2_Refundable_mKnQ": "¿Reembolso disponible?",
  "CS_pop_Whether_to_tvgd": "¿Crear un ticket sin una llamada asociada?",
  "CS_1_Send_an_oyHo": "¿Seguro que deseas enviar un correo electrónico a este usuario?",
  "CS_one_Upload_failed_tubs": "No se puede cargar. Inténtalo de nuevo.",
  "CS_tickets_Order_Work_UDue": "Ticket relacionado con la orden",
  "Magellan_improvement_ID_HTMT": "Identificación del ticket",
  "CS_Page_Type_of_Chyl": "Tipo de consulta",
  "CS_initialization_Select_user_QGGG": "Selecciona un tipo de usuario.",
  "Help_version_Answer_DVQw": "Contestar",
  "CS_improvement_Dial_man_vuMm": "Persona que llamó",
  "CS_one_Are_you_QXby": "¿Estás seguro de que quieres modificar esta razón de contacto? Una vez modificada, la RC entrará en vigencia en el país correspondiente. Informa a los colegas pertinentes en el país en cuestión.",
  "CS_info2_Data_Not_mVCx": "No hay datos disponibles.",
  "CS_information_Purpose_tIXL": "Destino",
  "CS_Page_Response_mode_tfSQ": "Modo de respuesta",
  "CS_Page_Order_Status_ZJEQ": "Estado de la orden",
  "CS_1_Internal_message_Dmzz": "Mensaje interno",
  "CS_1_More_online_ugOQ": "Ver más historial del chat",
  "CS_page_Cancelled_xyYr": "Cancelado",
  "CS_one_1_Please_EOBr": "1. Descarga y completa la siguiente plantilla.",
  "CS_one_Applicable_States_HNdh": "País aplicable",
  "CS_translation_Submission_akuK": "Enviar",
  "CS_one_Basic_information_akKk": "Información básica",
  "CS_Page_Driver_Mobile_mQCL": "Número de teléfono del conductor",
  "CS_one_Father_classification_ZASx": "Categoría principal de nivel 1 (en_US)",
  "CS_info_Select_user_WEYA": "Selecciona el tipo de usuario y el tipo de negocio para obtener las razones de contacto disponibles.",
  "CS_information_Order_Status_ZZvi": "Estado del viaje",
  "CS_Page_Please_choose_SkUr": "Selecciona...",
  "CS_one_Import_data_zhsI": "Importar datos",
  "CS_one_Applicable_Business_ERQA": "Categoría aplicable",
  "CS_1_Off_aqDQ": "Cerrar",
  "CS_info2__unk_MkzP": "Carga de la imagen",
  "CS_qa_Successfully_saved_GaYt": "El ticket se guardó correctamente",
  "CS_info2_User_Type_ylaU": "Tipo de usuario",
  "CS_1_Send_asynchronous_rowd": "Enviar un mensaje en la app y un correo electrónico",
  "CS_1_Cancel_UVIs": "Cancelar",
  "CS_info2_link_Text_Gvnh": "Información vinculada",
  "CS_Page_Enter_Passenger_vcdv": "Ingresar identificación del pasajero",
  "CS_one_Cancel_sSYi": "Cancelar",
  "CS_one_Add_VToU": "Agregar",
  "CS_one_Download_Template_XYvP": "Descargar plantilla",
  "CS_tickets_Compensation_Deducperiod_HFiB": "Tiempo de ejecución de la compensación o deducción",
  "CS_info2_Picture_text_mnMQ": "Descripción de la imagen",
  "CS_1_User_Mobile_aNYY": "Teléfono celular del usuario",
  "CS_Page_Product_line_gPCE": "Línea de productos",
  "CS_info_There_is_vxeJ": "No hay contenido disponible para esta razón de contacto. Para obtener más información, revisa la (base de conocimientos).",
  "CS_tickets_Today_klqB": "Hoy",
  "CS_notification_dwyv_UnUJ": "Este usuario que reporta es un socio flotilla. Solo se pueden aplicar herramientas de flotilla.",
  "CS_tickets_Search_dVXa": "Buscar",
  "CS_improvement_Driver_ZOiL": "Conductor",
  "CS_one_Scenarios_qeVe": "Escenario",
  "CS_reconstruction_Determination_MvvP": "Confirmar",
  "CS_2_Time_of_ynEo": "Fecha y hora del reembolso",
  "CS_1_operator_gItF": "Acción realizada por",
  "CS_info2_Image_address_QJoY": "URL de la imagen",
  "CS_tickets_Type_of_DvxN": "Tipo de ticket",
  "CS_tickets_Half_a_SjoS": "Últimos 6 meses",
  "CS_info_Into_the_OLWz": "Info entrante del usuario",
  "CS_page_Unable_to_sJgg": "No se pudo resolver el ticket.",
  "CS_1_Passengers_rXbp": "Pasajero",
  "CS_page_Unable_to_lQkV": "No se pudo cerrar el ticket.",
  "CS_1_Compensation_Deduction_eyNT": "Detalles de la compensación o deducción",
  "CS_page_Unable_to_lWwm": "No se pudo guardar el ticket temporalmente.",
  "CS_Page_Passenger_ID_WiFY": "Identificación del pasajero",
  "CS_Page_Clear_Query_qLSf": "Borrar criterios de búsqueda",
  "CS_info2_View_link_fyZT": "Ver link",
  "CS_tickets_Work_order_STXN": "Historial de tickets",
  "CS_2_Copy_successfully_rlpe": "Se copió correctamente.",
  "CS_one_Grade_classification_sVNq": "Categoría principal",
  "CS_Page_Driver_Details_Mnzk": "Detalles del conductor",
  "CS_page_Successful_temporary_sFHU": "El ticket se guardó temporalmente.",
  "CS_page_Successfully_created_ffvZ": "El ticket se creó correctamente.",
  "CS_Page_Purpose_rNGk": "Ubicación de destino",
  "CS_thpoptimization_Copy_the_CPlW": "Se copió el correo electrónico y se registró la acción. Recuerda seguir la política de seguridad de la información de la empresa.",
  "CS_1_Status_of_Dkxj": "Estado",
  "CS_Adjustment_VsHy_RwJo": "Ingresa un motivo para la omisión",
  "CS_reconstruction_Select_Business_DYpG": "Selecciona un tipo de negocio.",
  "CS_Settings_Can_not_wuTx": "El campo no puede quedar vacío.",
  "CS_1_Action_Name_sFel": "Acción",
  "CS_Page_Driver_Details_uNcn": "Detalles del conductor: identificación del conductor",
  "CS_pop_Action_zZIq": "Acciones",
  "CS_pop_Confirmation_lTpQ": "Aceptar",
  "CS_improvement_Phone_records_Kgdt": "Historial de llamadas",
  "Help_buchong_Reply_RcHf": "Responder",
  "CS_one_Classification_of_YYEd": "¿Es una razón de contacto (RC) relacionada con la seguridad?",
  "CS_info2_Association_ZCdq": "Vincular",
  "CS_1_Work_orders_fADf": "El mensaje interno para el ticket se envió correctamente.",
  "CS_qa_Collapse_DJRI": "Ver menos",
  "CS_improvement_Voice_duration_TNdW": "Duración de la llamada",
  "CS_1_Work_order_pUHt": "El correo electrónico para el ticket se envió correctamente.",
  "CS_1_Mail_address_Hxvv": "Correo electrónico",
  "CS_page_Actual_arrival_YPiM": "Hora de llegada real",
  "CS_Page_Driver_ID_HNzY": "Identificación del conductor",
  "CS_info_Select_a_CKYG": "Selecciona una ciudad. Si no hay ciudades disponibles, puedes seleccionar N/A.",
  "Magellan_improvement_When_you_WyDX": "Las órdenes serán canceladas una vez que se cierren. Te sugerimos seleccionarlas cuidadosamente.",
  "CS_tickets_Compensation_ID_PjEu": "Identificación de la compensación",
  "CS_5_When_the_WPIZ": "Este usuario que reporta es un conductor. Solo se pueden aplicar herramientas de conductor.",
  "CS_one_Please_confirm_BmHM": "Confirma las razones de contacto seleccionadas y haz clic en \"Confirmar\" para validarlas.",
  "CS_1_Send_email_oriC": "Enviar correo electrónico",
  "CS_tickets_One_week_YsBK": "Última semana",
  "CS_page_Whether_the_pGhP": "¿Seguro que este ticket se resolvió? Después de confirmar, el estado del ticket cambiará a “Procesando”.",
  "CS_one_Off_Zqiv": "Cerrar",
  "CS_2_For_security_YqmP": "Por seguridad, el correo electrónico del destinatario se encuentra oculto. Esto no afectará la comunicación.",
  "CS_info_Please_fill_yjjm": "Ingresa el número de celular",
  "CS_info2_Business_Type_KDsP": "Categorías de negocio",
  "CS_1_Send_internal_kufI": "Enviar mensaje",
  "CS_1_Save_dSGz": "Guardar",
  "CS_page_Priority_processor_Gwtc": "Asignado prioritario",
  "CS_1_The_author_xIBI": "De",
  "CS_one_Details_Page_mdDC": "Página de detalles de la razón de contacto",
  "CS_page_If_you_RZwt": "¿Seguro que deseas guardar temporalmente este ticket? Si lo haces, el estado del ticket cambiará a “Guardado temporalmente”.",
  "CS_page_Work_order_vikw": "El ticket se resolvió correctamente.",
  "CS_1_Type_kuvZ": "Tipo",
  "CS_1_Role_QhMU": "Rol",
  "CS_one_Please_confirm_ViBj": "Confirma las razones de contacto seleccionadas y haz clic en \"Confirmar\" para descartarlas.",
  "CS_2_Refund_history_NZXS": "Historial de reembolsos",
  "CS_info2_Related_Worksheets_TnzD": "Vincular ticket (opcional)",
  "CS_page_This_order_jAmf": "Paradas del viaje",
  "CS_Page_City_XSgD": "Ciudad",
  "CS_qa_Customer_Service_CeXF": "Agente de Soporte DiDi",
  "CS_Page_Passenger_List_ajVZ": "Lista de pasajeros",
  "CS_1_Latest_before_UTUl": "Ordenar por el más reciente",
  "CS_5_Copy_successfully_CcCu": "Copiado",
  "CS_1_During_Operation_xWpb": "Fecha y hora de la acción",
  "CS_one_Please_select_IHKO": "Selecciona un país y una línea de negocio",
  "CS_one_During_Operation_JDju": "Fecha y hora de la acción",
  "CS_qa_More_Paqa": "Más",
  "CS_info_Select_Channel_HWlg": "Selecciona un canal",
  "CS_info2_Rider_Issuing_TDAx": "Hora de la solicitud de viaje del pasajero",
  "CS_4_Contact_Records_NcjV": "Historial de contacto",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "Se vinculó un ticket",
  "Magellan_improvement_Information_Secure_LRtP": "Recordatorio de confidencialidad de la información",
  "CS_Page_Enter_driver_CirL": "Ingresar la identificación del conductor",
  "CS_Page_Select_driver_rrhQ": "Selecciona un tipo de conductor",
  "CS_qa_There_is_vPke": "{{inputbox}} tiene contenido no enviado. Al salir de esta página, se borrará el contenido. ¿Estás seguro de que quieres salir?",
  "CS_one_Father_classification_lZII": "Categoría principal de nivel 2 (en_US)",
  "CS_info_Mobile_phone_SGyc": "No se pudo encontrar la información del usuario porque el número de celular no es válido o el usuario no está registrado.",
  "CS_one_Export_data_YQDj": "Exportar datos",
  "CS_information_Departure_zaxW": "Punto de partida",
  "CS_TicketHandlingPage_This_CR_VWpW": "Los procedimientos normalizados de operación (PNO) manuales ya son compatibles con esta tasa de viajes finalizados. Procese el ticket según el PNO.",
  "CS_2_Work_Order_anVq": "Grupo de tickets",
  "CS_info_Select_Business_bhhu": "Selecciona un tipo de negocio",
  "CS_Adjustment_ZMnG_gsAL": "Otra",
  "CS_information_Order_ID_vVme": "Identificación del viaje",
  "CS_one_User_Type_iRnJ": "Tipo de usuario",
  "CS_4_Order_details_ulUl": "Detalles del viaje",
  "CS_one_Edit_LtHm": "Editar",
  "CS_info2_If_there_BivS": "Selecciona un ticket vinculado (si hay uno)",
  "CS_Page_Billing_models_otMq": "Tipo de vehículo",
  "CS_Page_Enter_your_kKAs": "Ingresar el número de teléfono",
  "CS_page_No_email_Uhdl": "No tienes permiso para responder por correo electrónico.",
  "CS_Adjustment_VZmt_VnjZ": "Selecciona un motivo para la omisión",
  "CS_Adjustment_oVPm_qPQP": "El usuario está fuera de línea o salió del chat",
  "CS_one_View_miAp": "Ver",
  "CS_fits_OUZR_woGE": "Línea de productos de la orden",
  "CS_1_Compensation_deduction_pTJS": "Canal de compensación o deducción",
  "CS_info2_More_akQx": "Ver más",
  "CS_1_Work_orders_cLNO": "El mensaje en la app para el ticket se envió correctamente.",
  "CS_1_Roaming_wzIe": "Roaming",
  "CS_5_Copy_qVgF": "Copiar",
  "CS_Page_Star_Standard_ICmt": "Calificación en estrellas",
  "CS_page_Estimated_arrival_QwhV": "Hora de llegada estimada",
  "CS_compensation_Refusal_of_hveW": "Compensación rechazada",
  "CS_initialization_Select_Order_dqhz": "Seleccionar un viaje",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "PNO manuales",
  "CS_Page_Passenger_Email_qveC": "Correo electrónico del pasajero",
  "CS_Page_Between_the_eqMJ": "Fecha y hora de creación",
  "CS_Page_Business_Type_nsHy": "Categoría de negocio",
  "CS_page_Do_you_tMFN": "¿Seguro que deseas cerrar este ticket?",
  "CS_2_Work_Order_fABY": "El número de identificación del ticket se copió correctamente.",
  "CS_Page_Pick_up_CNzD": "Punto de encuentro",
  "More": "Más",
  "CS_improvement_Unanswered_qcLt": "Sin respuesta",
  "CS_1_Related_Orders_hkRo": "Asociar orden",
  "CS_info_Comments_successfully_YcZj": "Comentario agregado",
  "CS_tickets_Enter_the_FCWt": "Ticket relacionado con el usuario que reporta",
  "CS_information_Booking_session_CBQY": "Hora programada",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "Mensaje interno",
  "CS_Page_Driver_ID_TPqW": "Nro. de identificación",
  "CS_info_Select_Work_KXNc": "Selecciona un grupo de tickets",
  "Help_conversations_Robot_chat_QzDc": "Historial de conversaciones de Chatbot",
  "CS_tickets_Between_the_mEqx": "Fecha y hora de creación",
  "CS_2_Passenger_Basic_FFNN": "Información básica del pasajero",
  "CS_page_Do_you_GgIB": "¿Deseas transferir el ticket a {{handler}} en {{ticketgroup}}?",
  "CS_1_Enter_text_NYGo": "Escriba su comentario aquí",
  "CS_1_Compensation_ID_BGFF": "Identificación de la compensación",
  "CS_1_Work_order_wyuA": "Información del ticket",
  "CS_info_Select_User_rSZo": "Selecciona un tipo de usuario",
  "CS_one_Classification_of_QAlG": "Razón de contacto",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "Mensaje en la app",
  "CS_pop_Can_t_QjXi": "¿No se encontró la llamada asociada?",
  "Help_version_Telephone_entry_PGun": "Menú de llamada telefónica",
  "CS_one_You_can_MflO": "Los caracteres especiales no están permitidos, excepto \"()\", \"?\" y los espacios",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "Respuesta externa",
  "CS_one_operator_Itcg": "Operador",
  "CS_one_Organization_eUqC": "Organización",
  "CS_5_Comply_with_YDuq": "Por favor, recuerda seguir las políticas de seguridad de la información de la empresa.",
  "CS_prompt_Driver_registration_mBqS": "No se encontró la tarea de revisión del registro del conductor.",
  "CS_Page_Order_ID_tWzK": "Identificación de la orden",
  "CS_one_Classification_of_jyqM": "Razón de contacto (RC) (en_US)",
  "CS_Page_Status_of_SBuB": "Estado del pago",
  "CS_Page_Enter_ID_IgwX": "Nro. de identificación",
  "TEXT_ERRMSG_OK": "OK",
  "Help_version_Thread_tmgY": "Razón de contacto",
  "CS_Page_Passenger_Mobile_ckjq": "Número de teléfono del pasajero",
  "CS_qa_User_Tjti": "Usuario",
  "CS_one_Classification_of_AlnN": "Razón de contacto (RC) (en_US)",
  "CS_1_Help_us_ilXL": "Da tu opinión sobre este proceso",
  "CS_one_Are_you_eqhN": "¿Estás seguro de que quieres crear una nueva razón de contacto? Una vez creada, la nueva RC entrará en vigencia en el país correspondiente. Informa a los colegas pertinentes en el país en cuestión.",
  "CS_initialization_Select_City_uKvx": "Seleccionar una ciudad",
  "CS_pop_Bind_fsRd": "Agregado",
  "CS_2_Classification_of_QmXS": "Razón de contacto",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "Robot",
  "ark.global.cs.field.title.ticket_tab_log": "Registros del ticket",
  "CS_pop_Yes_yDMc": "Sí",
  "CS_tickets_One_year_gmPi": "Último año",
  "CS_page_Internal_reply_pruf": "La respuesta interna no puede estar en blanco.",
  "ark.global.cs.field.title.ticket_tab_info": "Registros de información",
  "CS_Page_Front_ID_apqL": "Detalles de la flotilla: identificación de la flotilla",
  "CS_1_User_Name_dhWx": "Nombre del usuario",
  "CS_one_Batch_scrap_qzlO": "Descartar por lotes",
  "CS_info2__unk_RIxc": "Insertar",
  "CS_one_Parental_classification_zEhp": "Categoría principal (en_US)",
  "Help_buchong_Reply_Record_dsUU": "Historial de respuestas",
  "CS_info2_All_orders_yVmI": "Se muestran todas las órdenes de este usuario en los últimos 180 días",
  "CS_1_The_oldest_vXHS": "Ordenar por el más antiguo",
  "CS_monitor_Each_compensation_BfxO": "Todas las solicitudes de compensación están registradas. Asegúrate de que las solicitudes cumplan la Política de compensación de Servicio al cliente. Las solicitudes que no cumplan las pautas de la política se revisarán internamente.",
  "comTool.channelRefundERR": "este pedido no tiene factura para respaldar el reembolso original del canal",
  "review.auditInfo": "Detalles",
  "list.orderId": "ID de solicitud",
  "comTool.refundStatus": "estado del reembolso",
  "common.pleaseSelect": "seleccionar",
  "new.tags": "etiquetas",
  "comfort.vehicleModel": "Modelo del vehículo",
  "comfort.requiredYear": "Año >",
  "chat.save": "Guardar",
  "review.submitReview": "Enviar a revisión",
  "new.continueHandle": "continuar tratando con",
  "comTool.driverV": "No se puede compensar porque el tipo de usuario es pasajero",
  "comTool.balance": "balance de cuenta",
  "automation.action": "acción",
  "list.compensatePhone": "número de compensación",
  "staticConfig.false": "No",
  "work.businessTypeName": "Categoría",
  "new.orderInfo": "Información del viaje",
  "review.viewFlowchart": "Ver el diagrama de flujo",
  "comTool.riderCompensation": "Compensar a Pasajero",
  "comTool.driverActualRevenue": "En realidad el conductor cobra",
  "comTool.driverId": "ID de Conductor",
  "new.knowdgeBase": "Base de conocimiento",
  "comTool.passenger": "pasajero",
  "list.channel": "canal",
  "clipper.clipperTitle": "Informaciones del ticket relacionado de Safety de Clipper",
  "comTool.reasonForCompensation": "Motivo de la compensación",
  "comTool.driverPhone": "Número de teléfono del conductor",
  "review.commitTime": "Fecha y hora de envío",
  "common.system": "sistema",
  "common.more": "desplegar",
  "comTool.amountERR": "Error de entrada de cantidad",
  "staticConfig.yes": "Es",
  "staticConfig.operationSuccessfully": "Operación exitosa",
  "list.worksheetId": "Identificación de entradas",
  "comTool.status": "estado de pago",
  "comTool.driverDeduction": "Deducir a Conductor",
  "new.ticketRefreshV": "Este ticket ha sido actualizado, ¿continuará o no?",
  "common.jingmoThreeMonths": " Only Display Silence Log of Latest Three Month",
  "comTool.refundCost": "cantidad reembolsada",
  "list.amount": "Importe",
  "review.auditor": "Revisado por",
  "common.Toolbox": "Caja de instrumento",
  "common.ticketList": "registro de tickets",
  "comfort.city": "ciudad",
  "review.taskName": "Tipo de tarea",
  "staticConfig.channelSetting": "configuración de canal",
  "comTool.detailsOfCompensation": "Detalles del contenido de compensación",
  "clipper.clipperDetail": "Este ticket tiene uno relacionado de Safety de Clipper",
  "comTool.driverCompensation": "Compensar a Conductor",
  "review.submitReviewConfirm": "¿Estás seguro de que quieres enviar a revisión esta información?",
  "new.uploadFailed": "carga fallida Inténtalo de nuevo",
  "comTool.operationStatus": "resultado",
  "clipper.status": "Clipper Estado de ticket",
  "review.actions": "Acciones",
  "comTool.passengerCouponV": "No se puede solicitar un cupón de compensación, ya que el tipo de usuario es conductor",
  "work.Workbench": "Mi área de trabajo",
  "comTool.cost": "monto del pago",
  "chat.transfer": "Transferir",
  "chat.onlineResponse": "Mensaje en el Centro de ayuda",
  "review.auditTime": "Revisado el",
  "staticConfig.no": "No",
  "staticConfig.businessTypeName": "The name of Business Type",
  "new.NullEmergencyContact": "El usuario no ha establecido contacto de emergencia",
  "new.emergencyContact": "Contacto de emergencia",
  "common.confirm": "Confirmar",
  "comfort.model": "Modelo del vehículo",
  "clipper.T3first": "Clipper Tiempo de revisión inicial de T3",
  "common.abnormalReminder": "Advertencia de riesgo",
  "new.editTime": "editar tiempo",
  "comTool.pay": "Pasajeros",
  "review.undoChanges": "Deshacer cambios",
  "comTool.channelName": "Nombre del Canal",
  "callInfo.operation": "operación",
  "clipper.creationDate": "Clipper Tiempo de creado de ticket ",
  "common.continueTocompensate": "Compensar de todas formas",
  "comTool.coupon": "cupón",
  "list.amountRange": "Rango de importe",
  "comTool.channelRefund": "reembolso del canal original",
  "clipper.ticketID": "Clipper ID de ticket ",
  "comfort.search": "Search",
  "clipper.T2first": "Clipper Tiempo de revisión inicial de T2",
  "new.PleaseCreateTicket": "por favor crea una entrada primero",
  "comTool.refund": "reembolso",
  "detail.handle": "tratar con",
  "new.fileBig": "el archivo es demasiado grande Seleccione el archivo menos de 5M",
  "create.NewTicket": "Nuevo ticket",
  "staticConfig.true": "Es",
  "review.auditResult": "Resultado",
  "new.editUser": "editor",
  "review.modify": "Editar",
  "detail.handleV": "This ticket is under processing. Are you sure to claim it?",
  "new.refreshTicket": "actualizar esta página",
  "comTool.routeOfCompensation": "Ruta de compensación",
  "common.recommendationNotcompensate": "Recomendación: no compensar.",
  "common.to": "cambia a",
  "comTool.noOrderAll": "Este boleto no tiene orden, por lo que la compensación no puede ser respaldada",
  "clipper.clickToView": "Haga clic a ver más",
  "common.up": "colapso",
  "CS_Service_The_driver's_JbyZ": "Driver’s level was {{driver_level}} when this ticket was created",
  "CS_Service_Driver_Level_qpqY": "Driver Level",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "Unsuccessful",
  "Help_want__Change_pUeS": "More suggestions",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "Cancel"
}